import { createFileRoute } from '@tanstack/react-router'
import TrainingLocalDetailPage from '@/pages/resources/trainings-local/detail'

export const Route = createFileRoute('/app/resources/trainings-local/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <TrainingLocalDetailPage id={Number(id)} />
}
